import React from "react"
import { Input, Text, Flex, Box } from "@chakra-ui/react"

import Filters, { FilterType } from "./filters"

interface ActionBarProps {
    date: string
    setDate: (date: string) => void
    searchValue: string
    setSearchValue: (searchValue: string) => void
    filters?: FilterType
    setFilters: (filters?: FilterType) => void
    columns: number
    setColumns: (columns: number) => void
}

const ActionBar: React.FC<ActionBarProps> = ({
    date,
    setDate,
    searchValue,
    setSearchValue,
    filters,
    setFilters,
    columns,
    setColumns,
}) => {
    return (
        <Flex gridGap={4} align="flex-end" flexWrap="wrap" mb={2}>
            <Box>
                <Text>Date</Text>
                <Input
                    borderRadius="lg"
                    variant="filled"
                    w="300px"
                    type="date"
                    value={date}
                    onChange={(e: any) => {
                        setDate(e.target.value)
                    }}
                />
            </Box>
            <Box>
                <Text>Search Names</Text>
                <Input
                    borderRadius="lg"
                    variant="filled"
                    w="300px"
                    value={searchValue}
                    onChange={(e: any) => setSearchValue(e.target.value)}
                />
            </Box>
            <Filters
                filters={filters}
                setFilters={setFilters}
                columns={columns}
                setColumns={setColumns}
            />
        </Flex>
    )
}

export default ActionBar
